<template>
<span class="badge">
    <vs-chip class="pt-0 pb-0 pr-2 pl-2"
       :color="status ? 'success' : 'primary'"
       v-text="status ? $tc('transfer') : $tc('untransfer')">
    </vs-chip>
  </span>
</template>

<script>
export default {
  name: 'BadgeTransfer',
  props: {
    status: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
